import { type ReactNode } from 'react'
import { SearchField } from '@/components/SearchField'
import styles from './PrimaryControls.module.css'

export interface PrimaryControlsProps {
  value: string
  onChange: (val: string) => void
  actions: ReactNode
  testId?: string
}

export function PrimaryControls({
  value,
  onChange,
  actions,
  testId,
}: PrimaryControlsProps) {
  return (
    <div className={styles.root}>
      <div className={styles.search}>
        <SearchField
          embedded
          appearance="toolbar"
          stretch
          value={value}
          onChange={onChange}
          testId={testId}
        />
      </div>
      <div className={styles.actions}>{actions}</div>
    </div>
  )
}
